/* ============================================
   FitOnline Lab — Landing Page Scripts
   ============================================ */

(function() {
  'use strict';

  // --- Scroll animations (Intersection Observer) ---
  var animatedElements = document.querySelectorAll('.lab-animate-on-scroll');
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var siblings = entry.target.parentElement.querySelectorAll('.lab-animate-on-scroll');
        var delay = 0;
        siblings.forEach(function(sib, i) {
          if (sib === entry.target) delay = i * 80;
        });
        setTimeout(function() {
          entry.target.classList.add('visible');
        }, delay);
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -40px 0px'
  });
  animatedElements.forEach(function(el) { observer.observe(el); });

  // --- Typing animation for Step 1 ---
  var typingEl = document.getElementById('labTypingDemo');
  if (typingEl) {
    var text = typingEl.textContent;
    typingEl.textContent = '';
    var charIndex = 0;
    var started = false;

    var typingObserver = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting && !started) {
        started = true;
        typeNextChar();
        typingObserver.unobserve(typingEl);
      }
    }, { threshold: 0.5 });
    typingObserver.observe(typingEl);

    function typeNextChar() {
      if (charIndex < text.length) {
        typingEl.textContent += text[charIndex];
        charIndex++;
        setTimeout(typeNextChar, 60 + Math.random() * 40);
      }
    }
  }

  // --- FAQ accordion ---
  document.querySelectorAll('.lab-faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.lab-faq-item');
      var isActive = item.classList.contains('active');

      document.querySelectorAll('.lab-faq-item.active').forEach(function(activeItem) {
        activeItem.classList.remove('active');
      });

      if (!isActive) {
        item.classList.add('active');
      }
    });
  });

  // --- Compare table scroll hint fade ---
  var compareWrapper = document.querySelector('.lab-compare-table-wrapper');
  if (compareWrapper) {
    compareWrapper.addEventListener('scroll', function() {
      var atEnd = compareWrapper.scrollLeft + compareWrapper.clientWidth >= compareWrapper.scrollWidth - 2;
      compareWrapper.classList.toggle('scrolled-end', atEnd);
    });
  }

  // --- Smooth scroll for anchor links within lab section ---
  document.querySelectorAll('.C-lab-landing a[href^="#lab-"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var targetId = anchor.getAttribute('href');
      if (targetId === '#') return;
      var target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        var offset = 80;
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });

})();
